<template>
<div class="param-copy-container">
    <!-- 操作按钮 -->
    <div class="copy-buttons ">
        <Button type="success" icon="ios-analytics-outline" 
        :disabled="!sourceDevice || selectedItems.length === 0" @click="handleCompareParams" class="copy-button"
        :loading="compareLoading">
            {{ getTranslation("b060") }}
        </Button>&nbsp;
            <Button type="primary" icon="md-download" :disabled="!sourceDevice || selectedItems.length === 0"
        @click="handleCopyParams" class="copy-button" :loading="downloadLoading">
        {{ getTranslation("b059") }}
      </Button>
        
    </div>
    <Row type="flex" class="device-selection">
        <!-- 源设备选择 -->
        <Col flex="1">
        <Card class="source-device-card" dis-hover>
            <template #title>
                <div class="card-title">
                    <Icon type="ios-copy" />
                    <span>{{ getTranslation('b057') }}</span>
                </div>
            </template>
            <div class="device-selector">
                <Select :filterable="true" :transfer="true" v-model="sourceDevice" :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')" size="small" class="device-select">
                    <Option v-for="item in macList" :value="item.id" :key="item.id" :label="item.code">{{ item.code }}</Option>
                </Select>
            </div>
        </Card>
        </Col>

        <!-- 目标设备选择 -->
        <Col flex="1">
        <Card class="target-device-card" dis-hover>
            <template #title>
                <div class="card-title">
                    <Icon type="ios-list" />
                    <span>{{ getTranslation('b058') }}</span>               
                    <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll" size="default">
                        <span>{{ getTranslation('b056') }}</span>
                    </Checkbox>
             
                </div>
            </template>
            <div class="target-devices">
                <div class="devices-list">
                    <CheckboxGroup v-model="selectedItems">
                        <Row type="flex" v-for="item in macList" :key="item.id">
                            <Col flex="1" class="device-checkbox-col">
                            <div class="device-checkbox-item">
                                <Checkbox :label="item.id" :disabled="item.id === sourceDevice" class="device-checkbox">
                                    <span :class="{ 'disabled-text': item.id === sourceDevice }">
                                        {{ item.code }}
                                    </span>
                                </Checkbox>
                            </div>
                            </Col>
                        </Row>
                    </CheckboxGroup>
                </div>
            </div>
        </Card>
        </Col>
    </Row>

	<!-- 系统参数比较结果弹窗 -->
	<Modal v-model="compareModalVisible" :title="getTranslation('b004')" :fullscreen="true"  footer-hide :mask-closable="false">		
		<div v-if="compareResults && compareResults.length >0" style="text-align:center;padding:0px 0;">
        <Row class="table-header" type="flex">
          <Col style="width: 200px; flex-shrink: 0;" class="table-header">{{ getTranslation("b065") }}</Col>
          <Col flex="1" class="table-header" v-if="compareSource && compareSource.code">{{ compareSource.code }}</Col>
          <Col flex="1" class="table-header" v-for="(oneCompare, oneRes) in filteredTargetResults" :key="'compare-source-' + oneRes">
            {{ oneCompare.target ? oneCompare.target.code : '' }}(<span class="group-diff-count">{{ getDiffCount(oneCompare) }}</span>)
          </Col>
        </Row>
        <Row v-if="compareResults && compareResults.length>0"  type="flex" >         
          <Col flex="1">
            <Row v-for="(item,index) in compareResults[0].items" :key="index"  type="flex" :class="[ 'table-row',  ]">
              <Col style="width: 200px; flex-shrink: 0;" class="table-cell" >{{ item.Alias }}</Col>
              <Col flex="1" class="table-cell">{{ item.Original }}</Col>
              <Col flex="1" :class="[ 'table-cell',{ 'abnormal-row': !item.Same } ]">{{ item.Present }}</Col>
                <Col 
                    v-for="(oneCompare, oneRes) in filteredCompareResults"
                    :key="'compare-' + oneRes + '-' + index"
                    flex="1" 
                    :class="[ 'table-cell',{ 'abnormal-row': !oneCompare.items[index].Same } ]"
                    >
                    {{ oneCompare.items[index].Present }}
                    </Col>
            </Row>
        </Col>
      </Row>

		</div>
	</Modal>

</div>
</template>

<script>
import {
    API_URL
} from '@/constants/const.js'
import axios from 'axios';
import {
    postJsError
} from '@/util/util.js'
import {
    Button,
    Select,
    Option,
    Row,
    Col,
    Checkbox,
    CheckboxGroup,
    Card,
    Icon,
    Modal,   

} from 'view-design';
import {
    mapGetters
} from 'vuex';
export default {
    name: 'ParamCopy',
    components: {
        Button,
        Select,
        Option,
        Row,
        Col,
        Checkbox,
        CheckboxGroup,
        Card,
        Icon,
        Modal,    

    },
    props: {

    },
    data() {
        return {
            macList: [],
            selectedItems: [],
            checkAll: false,
            indeterminate: false,
            sourceDevice: null,
            compareModalVisible: false,
            compareLoading: false,
            compareResults: [],
            downloadLoading: false,
            compareSource:null,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        filteredCompareResults() {
        // 过滤掉第一个元素，并且确保数据存在
        if (!this.compareResults || this.compareResults.length <= 1) {
            return []
        }
        return this.compareResults.filter((item, index) => index > 0 && item && item.items)
        },
        filteredTargetResults() {
        // 过滤掉第一个元素，并且确保数据存在
        if (!this.compareResults || this.compareResults.length < 1) {
            return []
        }
        return this.compareResults.filter((item) =>  item && item.target)
        }
    },
    watch: {

    },
    created() {
        this.init();
    },
    mounted() {

    },
    methods: {
        init() {
            this.getData();
        },
        getData() {
            let url = API_URL["libraryInit"];
            let params = {}
            axios.get(url, {
                    params: params
                })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.macList = res.data.data.macList;
                        if (this.macList.length > 0) {
                            this.sourceDevice = this.macList[0].id
                        }
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('m041'));
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        handleCheckAll() {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) {
                // 排除源设备
                this.selectedItems = this.macList
                    .filter(item => item.id !== this.sourceDevice)
                    .map(item => item.id);
            } else {
                this.selectedItems = [];
            }
        },

        getDeviceName(deviceId) {
            const device = this.macList.find(item => item.id === deviceId);
            return device ? device.code : '';
        },

        async handleCopyParams() {
            if (!this.sourceDevice || this.selectedItems.length === 0) {
                this.$Message.warning(this.getTranslation('b134'));
                return;
            }
            this.downloadLoading = true;
            this.$Modal.confirm({                
                title: this.getTranslation('b135'),
                okText: this.getTranslation('b181'),
                cancelText: this.getTranslation('b182'),
                content: this.getTranslation('b137') + this.getDeviceName(this.sourceDevice) + this.getTranslation('b138'),
                 onOk: async() => {
                    let url = API_URL["libraryCopyPost"];
                    let formData = new FormData();
                    formData.append('mac', this.sourceDevice);
                    formData.append('items', this.selectedItems.join(','));
                    let res = await axios.post(url,
                            formData
                        )
                        .catch((err) => {
                            this.downloadLoading = false;
                            postJsError(err)
                            return;                            
                        })
                        if (res && res.data && res.data.code == 200) {
                            this.$Message.success(res.data.msg);
                        } else if (res && res.data && res.data.msg) {
                            this.$Message.error(res.data.msg);
                        } else {
                            this.$Message.error(this.getTranslation('c001'));
                        }
                        this.downloadLoading = false;
                    },
                    onCancel: () => {
                        this.downloadLoading = false;
                    }   
                
            });
            
        },
        async handleCompareParams() {
            if (!this.sourceDevice || this.selectedItems.length === 0) {
                this.$Message.warning(this.getTranslation('b134'));
                return;
            }
            
            this.compareLoading = true;
            this.compareResults = [];
            

            let url = API_URL["librarySystemCompare"];
            let formData = new FormData();
            formData.append('mac', this.sourceDevice);
            formData.append('items', this.selectedItems.join(','));
            let res = await axios.post(url,
                formData,{timeout: 300000}
            ).catch((err) => {
                postJsError(err)                
                this.compareLoading = false;                
            })
            if (res && res.data && res.data.code == 200) {
                this.compareModalVisible = true;
                let data = res.data.data;
                this.compareResults = data.comparisons || [];                
                this.compareSource = data.source || null;
                
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
            this.compareLoading = false;
        },

        rowClassName(row) {
            if (!row.Same) {
                return 'compare-diff-row';
            }
            return '';
        },
        getDiffCount(group) {
        if (!group.items) return ''
        const diffCount = group.items.filter(item => !item.Same).length
        return diffCount > 0 ? diffCount + ' '+this.getTranslation('p085') : this.getTranslation('p086')
        },

    }

}
</script>

<style scoped>
@import url("../../../assets/style/list.css");
@import url("../../../assets/style/tab.css");
.param-copy-container {
    padding: 20px;
    margin: 0 auto;
}

.device-selection {
    margin-bottom: 24px;
    width: 100%
}

.source-device-card {
    height: 50%;
    overflow: auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}

.target-device-card {
    height: 50%;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
    display: flex;
    flex-direction: column;
}
.target-device-card :deep(.ivu-card-body) {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.card-title i {
    font-size: 18px;
    color: #2d8cf0;
}

.device-selector {
    padding: 16px 0;
}

.device-select {
    width: 100%;
    margin-bottom: 12px;
}

.target-devices {
    padding: 16px 0;
}

.select-all-section {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e8eaec;
}

.devices-list {
    margin-bottom: 16px;
}

.device-checkbox-col {
    margin-bottom: 12px;
}

.device-checkbox-item {
    display: flex;
    align-items: center;
}

.device-checkbox {
    width: 100%;
}

.device-checkbox :deep(.ivu-checkbox) {
    margin-right: 8px;
}

.disabled-text {
    color: #c5c8ce;
    cursor: not-allowed;
}

.copy-buttons {
    text-align: center;
    margin: 10px 0;
}

.copy-button {
    margin-right: 12px;
    min-width: 160px;
    height: 30px;
    font-size: 14px;
}

/* 比较结果样式 */
:deep(.compare-diff-row td) {
    color: #ed4014 !important;
    font-weight: bold;
    background-color: #fff2f0 !important;
}
.abnormal-row {
  background-color: #fff2f0 !important;
  border-left: 3px solid #ff4d4f;
}

.abnormal-row .table-cell {
  color: #ff4d4f;
}
</style>
